import { render, staticRenderFns } from "./SelectReason.vue?vue&type=template&id=b3c96268&"
import script from "./SelectReason.vue?vue&type=script&lang=js&"
export * from "./SelectReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports